import React, { useMemo, useState } from 'react';
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../../_metronic/_partials/controls';

import { useBankKurbanUIContext } from './BankKurbanUIContext';
import { BankKurbanTable } from './bank-kurban-table/BankKurbanTable';
import { Collapse, Badge } from 'react-bootstrap';
import { BankKurbanFilter } from './bank-kurban-filter/BankKurbanFilter';

export function BankKurbanCard(props) {

    const bankKurbanUIContext = useBankKurbanUIContext();
    const bankKurbanUIProps = useMemo(() => {
        return {
            newBankKurbanButtonClick: bankKurbanUIContext.newBankKurbanButtonClick,
            openProcessPage: bankKurbanUIContext.openProcessPage,
            setQueryParams: bankKurbanUIContext.setQueryParams,
            queryParams: bankKurbanUIContext.queryParams,
            filterType: bankKurbanUIContext.filterType,
            statusList: bankKurbanUIContext.statusList
        };
    }, [bankKurbanUIContext]);

    const [statusFilter, setStatusFilter] = useState(false);
    const [open, setOpen] = useState(false);



    const changeShow = () => {
        setOpen(!open);

        // Set Status Filter To False
        setStatusFilter(false);
        const filter = bankKurbanUIContext.queryParams.filter;
        for (const [key, value] of Object.entries(filter)) {
            if (value !== '') {
                setStatusFilter(true);
            }
        }
    };

    return (

        <Card>

            <CardHeader title="Daftar Import Bank Kurban">
                <CardHeaderToolbar>
                    <button
                        type="button"
                        className="btn btn-warning mr-2"
                        onClick={changeShow}
                        aria-controls="collapse-filter-donasi"
                        aria-expanded={open}
                    >Cari
                    </button>
                    <a href="https://docs.google.com/spreadsheets/d/1lXal6p9U22BZLiHI2jEquhXC0TpG0vEvZ811jodZQb8/edit?usp=sharing">
                        <button
                            type="button"
                            className="btn btn-success mr-2"
                        // onClick={bankKurbanUIProps.downloadTemplate}
                        >Download Template
                        </button>
                    </a>

                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={bankKurbanUIProps.newBankKurbanButtonClick}
                    >Import Bank Baru
                    </button>
                </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
                <Collapse in={open}>
                    <div id="collapse-filter-donasi">
                        <BankKurbanFilter />
                    </div>
                </Collapse>
                <BankKurbanTable />

            </CardBody>
        </Card>

    );
};
